import type { StateCreator } from 'zustand';

import type { ProductType } from '../../types/product-type.enum';

export interface Suggestion {
  id: string;
  name: string;
  description?: string;
  targetLink: string;
}

export interface InputSlice {
  // State
  hash: string | undefined;
  type: ProductType | undefined;
  input: string | undefined;
  email: string | undefined;
  address: string | undefined;
  targetLink: string | undefined;
  suggestions: Suggestion[] | undefined;

  // Actions (stable functions following flux-inspired pattern)
  setHash: (hash: string | undefined) => void;
  setType: (type: ProductType | undefined) => void;
  setInput: (input: string | undefined) => void;
  setEmail: (email: string | undefined) => void;
  setAddress: (address: string | undefined) => void;
  setTargetLink: (link: string | undefined) => void;
  setSuggestions: (suggestions: Suggestion[] | undefined) => void;
  reset: () => void;
}

const initialState = {
  hash: undefined,
  type: undefined,
  input: undefined,
  email: undefined,
  address: undefined,
  targetLink: undefined,
  suggestions: undefined,
};

export const createInputSlice: StateCreator<InputSlice, [], [], InputSlice> = (
  set,
) => ({
  ...initialState,

  setHash: (hash) => set({ hash }),

  setType: (type) => set({ type }),

  setInput: (input) => set({ input }),

  setEmail: (email) => set({ email }),

  setAddress: (address) => set({ address }),

  setTargetLink: (targetLink) => set({ targetLink }),

  setSuggestions: (suggestions) => set({ suggestions }),

  reset: () => set(initialState),
});
